import { UserDoc } from '@gooduncles/gu-app-schema';
import { ICellRendererParams } from 'ag-grid-community';
import { useEffect } from 'react';

import useSWRUser from 'src/hooks/swr/useSWRUser';

interface AgCellUserProps extends ICellRendererParams {
  userId: string;
  field: keyof UserDoc;
}

const AgCellUser = (params: AgCellUserProps) => {
  const userId = params.userId;
  const { user } = useSWRUser(userId);
  const value = (user?.[params.field] ?? '') as string;

  useEffect(() => {
    if (params.setValue) {
      params.setValue(value);
    }
  }, [params, value]);

  return <span>{value}</span>;
};

export default AgCellUser;
